import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Injectable()
export class LoadingTask {

    private IsLoadingSubject: Subject<boolean> = new Subject<boolean>();
    private IsLoadingAndBlockingSubject: Subject<boolean> = new Subject<boolean>();
    IsLoading = 0;

    constructor() {
    }

    get LoadingEmitter() {
        return this.IsLoadingSubject;
    }

    get LoadingAndBlockingEmitter() {
        return this.IsLoadingAndBlockingSubject;
    }

    // TODO To Test for a big refactoring of services classes
    start(callback: (x: any) => Observable<any>, ...parameter: any) {

        this.activateLoading();
        return callback(parameter).pipe(
            catchError(() => 'fwefe'),
            finalize(() => this.deactivateLoading()));
    }

    activateLoading(withBlocking?: boolean) {
        if (withBlocking && this.IsLoading === 0) {
            this.IsLoadingAndBlockingSubject.next(true);
        } else if (this.IsLoading === 0) {
            this.IsLoadingSubject.next(true);
        }
        this.IsLoading++;
    }

    deactivateLoading() {
        if (this.IsLoading > 0) {
            this.IsLoading--;
        }
        if (this.IsLoading === 0) {
            this.IsLoadingAndBlockingSubject.next(false);
            this.IsLoadingSubject.next(false);
        }
    }

    cleanLoading() {
        this.IsLoading = 0;
        this.IsLoadingAndBlockingSubject.next(false);
        this.IsLoadingSubject.next(false);
    }
}
